
import Money from "../../utils/Money";
import React from "react";
import PropTypes from "prop-types";
import "./Currency.scss";
import {useSelector} from "react-redux";
import {selectUserCultureLg} from "../../stores/account/account.selectors";
import GlobalConst from "../../constants/GlobalConst";

const Currency = (props)=>{

    let leftSymbol = null;
    let rightSymbol = null;

    const lg = useSelector(selectUserCultureLg);

    switch(props.currency){
        case "MXN":
        case "US":
            leftSymbol = "$";
            break;
        case "TF":
            if(GlobalConst.FEATURES.DOTFR)
                rightSymbol = "€*";
            else
                leftSymbol = <><span className="tf-left">*</span>$</>;
            break;
        case "CAD":
            rightSymbol = "$";
            break;
        case "EUR":
            rightSymbol = "€";
            break;
        case "NB_PTS":
            rightSymbol = "€*";
            break;
        default:
            if(GlobalConst.FEATURES.DOTFR)
                rightSymbol = "€";
            else
                leftSymbol = "$";
            break;
    }

    let amount = parseFloat(props.value);

    // Apply toK logic
    if (props.toK && amount >= 1000) {
        amount = (amount / 1000).toFixed(1);
        amount += 'K';
    } else {
        amount = new Money(amount, lg).toString();
    }

    if (props.removeDecimal) {
        amount = amount.split('.')[0];
    }

    return <span className={"Currency " + (props.className || '')}>{(leftSymbol || "")}{amount}{(rightSymbol || "")}</span>
};
Currency.propTypes = {
    value: PropTypes.number.isRequired,
    currency: PropTypes.string,
    removeDecimal: PropTypes.bool,
    toK: PropTypes.bool,
    lg: PropTypes.string
};
export default Currency;
